import React, { useEffect } from "react";
import Popup from "../Component/Popup";
import HomeSlider from "../Component/HomeSlider";
import TopperXII from "../Component/TopperXII";
import TopperX from "../Component/TopperX";
import Birthday from "../Component/Birthday";
import Events from "../Component/Events";
import News from "../Component/News";
import Campuscare from "../Component/Campuscare";
import OnlineRegistration from "../Component/OnlineRegistration";
// import Facilities from'../Component/Facilities'
import Gallery from "../Component/Gallery";
// import Message from '../Component/Message'
import PageLoader from "../Component/PageLoader";
import { Link } from "react-router-dom";
import Message from "../Component/Message";
import LazyLoad from "react-lazyload";
import Cocurricular from "../Component/Cocurricular";
const Home = () => {
  return (
    <>
      <Campuscare />

      <Popup />

      <OnlineRegistration />

      {/* <Popup /> */}

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 col-md-12 padding-0 order-lg-1 order-md-2">
            <div className="about-news">
              <News />
            </div>
          </div>
          <div className="col-lg-9 col-md-12 padding-0 order-1">
            <HomeSlider />
          </div>
        </div>
      </div>

      <div className="aboutmidsec padded-sec">
        <div className="button">
          <p>
            <Link to="/Tc" target="_blank">
              Transfer Certificate
            </Link>
          </p>
        </div>
        <div className="button">
          <p>
            {" "}
            <Link to="https://canossa.campuscare.info/" target="_blank">
              Online Payment
            </Link>
          </p>
        </div>
        <div className="button">
          <p>
            {" "}
            <Link to="/pphelp" target="_blank">
              Parent Guidelines
            </Link>
          </p>
        </div>
        <div className="phone">
          <p>
            <Link to="/" target="_blank">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/phone.gif" />
            </Link>
          </p>
        </div>
        <div className="button">
          <p>
            <Link to="/" target="_blank">
              Alumni Registration
            </Link>
          </p>
        </div>
        <div className="button">
          <p>
            <Link to="/ERPSoftware"> ERP Software </Link>
          </p>
        </div>
        <div className="button">
          <p>
            <Link to="/fee">School Fee </Link>
          </p>
        </div>
      </div>

      <div className="aboutSection padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 abt-content-block">
              <div className="abt-content section-title">
                <div className="title">
                  <p>ABOUT</p>
                  <h2>Cannosa School</h2>
                </div>
                <p>
                  The Canossian Daughters of Charity is Religious Institute
                  founded by St. Magdalene of Canossa in 1808 at Verona, Italy.
                  Saint Magdalene of Canossa was born in 1774 in an aristocratic
                  family of Verona. She grew up at a time when corowuption,
                  abuse and social injustice were rampant in Italy and other
                  parts of Europe. The situation was worsened by the Napoleonic
                  Wars and the invasion of foreign powers in Italy. Inspired by
                  her love of God and deeply empathetic towards the suffering of
                  the poor, Magdalene gave up the luxury and security of her
                  palace, to establish institutions for the needy, the sick and
                  suffering. The institute of the Canossian Daughters of Charity
                  is Present in thirty-three countries throughout the world. Our
                  Sisters first came to India in 1889. Today we have 75 branches
                  in India, dedicated to education, medical services and social
                  uplift of the poorer sections of society. The education of the
                  girl-child and the empowerment of women are our special
                  concerns.
                </p>
                <button className="button arrow_btn-view">
                  <Link to="/about">
                    {" "}
                    READ MORE <i class="bi bi-arrow-right"></i>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="about-img">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/about-us1.png"
                    className="img-fluid"
                    alt="Cannosa school"
                  />
                </LazyLoad>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="about-flex">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/about-us2.png"
                    className="img-fluid"
                    alt="Cannosa school"
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="four-block padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="four-blk">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/aims.gif"
                    alt="Cannosa school"
                  />
                </LazyLoad>
                <h3>Aims and objectives</h3>
                <p>
                  The Primary aim of Canosa School is to impart sound formation
                  (spiritual, mental, moral, social and physical) based on the
                  principles of Christian faith, to the members of the Christian
                  Community...<span>Read More</span>
                </p>
              </div>
            </div>
            <div className="col-lg-4  col-md-6">
              <div className="four-blk">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/vision.gif"
                    alt="Cannosa school"
                  />
                </LazyLoad>
                <h3>Vision</h3>
                <p>
                  To promote integral growth of the personality of our students,
                  by giving particular attention to the formation of the heart
                  in order to draw out the best in them.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="four-blk">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/mission.gif"
                    alt="Cannosa school"
                  />
                </LazyLoad>
                <h3>Mission</h3>
                <p>
                  We believe that every child has the power to develop his/ her
                  potentialities through continuous formation of their
                  conscience, which will enable them to know their rights and
                  duties towards God and the Humanity.
                </p>
              </div>
            </div>
            {/* <div className='col-lg-12'>
              <button className='button'><Link to="/">READ MORE </Link></button>
            </div> */}
          </div>
        </div>
      </div>

      <div className="toper-birthday padded-sec">
        <div className="container-fluid section-title">
          <div className="row">
            <div className="col-lg-8">
              <div className="top-ach">
                <div className="title">
                  <p>our shining stars</p>
                  <h2>Achievers</h2>
                </div>
                <div className="toper-block">
                  <div>
                    <h2>XII TOPPERS</h2>
                    <TopperX />
                    <button className="button arrow_btn-view">
                      <Link to="/topperXII">
                        {" "}
                        View All <i class="bi bi-arrow-right"></i>
                      </Link>
                    </button>
                  </div>
                  <div>
                    <h2>X TOPPERS</h2>
                    <TopperXII />
                    <button className="button arrow_btn-view">
                      <Link to="/topperX">
                        {" "}
                        View All <i class="bi bi-arrow-right"></i>
                      </Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 birthday_section">
              <div className="title">
                <p>STARS OF THE DAY</p>
                <h2>
                  HAPPY <span> BIRTHDAY</span>
                </h2>
              </div>
              <Birthday />
            </div>
          </div>
        </div>
      </div>
      <div className="message_section padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className="title">
                <p>FROM THE DESK OF</p>
                <h2>MESSAGE SECTION</h2>
              </div>
            </div>
            <div className="col">
              <Message />
            </div>
          </div>
        </div>
      </div>
      <div className="facilities">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <p>Special facilities</p>
                <h2>School facilities</h2>
              </div>
            </div>
            <div className="col-md-4">
              <div className="facility_blk dark">
                <h3>LABORATORY</h3>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/laboratory.png"
                  className="img-fluid"
                  alt="cannosa school"
                ></img>
                <button className="button">
                  <Link to="/laboratory">Read More</Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="facility_blk">
                <h3>MUSIC</h3>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/music.png"
                  className="img-fluid"
                  alt="cannosa school"
                ></img>
                <button className="button">
                  <Link to="/music">Read More</Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="facility_blk dark">
                <h3>LIBRARY</h3>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/library.png"
                  className="img-fluid"
                  alt="cannosa school"
                ></img>
                <button className="button">
                  <Link to="/library">Read More</Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="event padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-6 section-title">
              <div className="title">
                <p>happening in our school</p>
                <h2>
                  LATEST <span> EVENTS</span>
                </h2>
              </div>
              <Events />
            </div>
            <div className="col-lg-6 section-title">
              <div className="title">
                <p>Shaping Skills, Nurturing Talents</p>
                <h2>Co-curricular Achievements</h2>
              </div>
              <div className="co-curricular">
                <Cocurricular />
                <p>
                  Under the supervision of Rakesh Dubey and Rajesh Tripati, 5
                  girls got Silver Medal and 2 girls were felicitated by Bronze
                  Medal in State Level Yoga held in Agra. Our 3 girls got
                  selected for National Level Yoga in Bhopal, and among them,
                  Shreya Singh Pal got selected for the International Yoga
                  Competition.
                </p>
              </div>
              {/* <button className="button mt-30">
            <Link to="/"> View All</Link>
          </button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-md-12 section-title">
              <div className="title">
                <p>Some Precious Moments</p>
                <h2>Photo Gallery</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
              <button className="button">
                <Link to="/photoGallery"> View All </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
